import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';

export const COLOR_SCHEMES = ['auto', 'light', 'dark'];

export const getColorScheme = () => {
  const raw = LocalStorage.get(LOCAL_STORAGE_KEYS.COLOR_SCHEME);
  return COLOR_SCHEMES.includes(raw) ? raw : 'auto';
};

export const setColorTheme = isOSOnDarkMode => {
  const selectedColorScheme = getColorScheme();
  if (
    (selectedColorScheme === 'auto' && isOSOnDarkMode) ||
    selectedColorScheme === 'dark'
  ) {
    document.body.classList.add('dark');
    document.documentElement.style.setProperty('color-scheme', 'dark');
  } else {
    document.body.classList.remove('dark');
    document.documentElement.style.setProperty('color-scheme', 'light');
  }
};

export const applyColorScheme = theme => {
  const next = COLOR_SCHEMES.includes(theme) ? theme : 'auto';
  LocalStorage.set(LOCAL_STORAGE_KEYS.COLOR_SCHEME, next);
  if (typeof window === 'undefined') return next;
  setColorTheme(window.matchMedia('(prefers-color-scheme: dark)').matches);
  return next;
};
